import { Modal, Form, Input, message } from "antd";
import React from "react";

const useTranslation = () => {
  return { t: (text: any) => text };
};

export const TemplateModal = ({
  name,
  setIsTemplateModalVisible,
  isTemplateModalVisible,
  createTemplateTask,
  parentForm
}: {
  name?: string;
  setIsTemplateModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isTemplateModalVisible: boolean;
  createTemplateTask: any;
  parentForm: any;
}) => {
  if (!isTemplateModalVisible) return null;

  return (
    <TemplateModalContent
      name={name}
      setIsTemplateModalVisible={setIsTemplateModalVisible}
      createTemplateTask={createTemplateTask}
      parentForm={parentForm}
    />
  );
};

const TemplateModalContent = ({
  name,
  setIsTemplateModalVisible,
  createTemplateTask,
  parentForm
}: {
  name?: string;
  setIsTemplateModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  createTemplateTask: any;
  parentForm: any;
}) => {
  const { t } = useTranslation();

  const [templateForm] = Form.useForm();

  // Handle create new template
  const handleCreateTemplate = async () => {
    try {
      const values = await templateForm.validateFields();
      const newTemplate = await createTemplateTask.mutateAsync(values);

      // Set the new template in the main form
      parentForm.setFieldsValue({ template_task_id: newTemplate.id });

      setIsTemplateModalVisible(false);
      templateForm.resetFields();
      message.success(t("Template criado com sucesso!"));
    } catch (error) {
      console.error("Falha ao criar o template:", error);
    }
  };

  return (
    // TODO: Investigate why `destroyOnClose` is not working as expected here
    <Modal
      title={t("Criar template")}
      open={true}
      onCancel={() => {
        setIsTemplateModalVisible(false);
        templateForm.resetFields();
      }}
      onOk={handleCreateTemplate}
      okText={t("Criar")}
      cancelText={t("Cancelar")}
      confirmLoading={createTemplateTask.isLoading}
    >
      <Form
        form={templateForm}
        layout="vertical"
        initialValues={{
          name
        }}
      >
        <Form.Item
          name="name"
          label={t("Nome do template")}
          rules={[
            {
              required: true,
              message: t("Por favor, insira um nome de template")
            }
          ]}
        >
          <Input placeholder={t("Insira o nome do template")} />
        </Form.Item>

        <Form.Item name="description" label={t("Descrição")}>
          <Input.TextArea
            rows={3}
            placeholder={t("Insira a descrição do template")}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
